// src/pages/dashboard/ChangePasswordPage.js
import React, { useState } from 'react';
import { Form, Button, Alert, Card, Spinner, Container, Row, Col } from 'react-bootstrap';
import MetaTags from '../../components/MetaTags';
import './ChangePasswordPage.css'; // Importing your premium CSS

const ChangePasswordPage = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError("New password and confirm password don't match.");
      return;
    }
    if (newPassword.length < 6) { 
        setError("New password must be at least 6 characters long.");
        return;
    }

    setLoading(true);
    
    // Simulating API Call logic
    try {
        console.log("Changing password:", { currentPassword, newPassword });
        // In a real app, you would use:
        // const response = await api.post('/change-password', { currentPassword, newPassword });
        
        // Mocking Success after 1.5 seconds
        setTimeout(() => {
          setSuccess('Password updated successfully!');
          setCurrentPassword(''); 
          setNewPassword(''); 
          setConfirmPassword('');
          setLoading(false);
        }, 1500);

    } catch (err) {
        setError('Failed to update password. Please try again.');
        setLoading(false);
    }
  };

  return (
    <div className="change-password-page-bg" >
      <MetaTags title="Change Password - BookMyAudition" />
      
      <Container>
        {/* --- Header Section --- */}
        <div className="text-center mb-5">
          <h2 className="change-pass-title">Security Settings</h2>
          <p className="change-pass-subtitle">Protect your account by updating your password regularly</p>
        </div>

        {/* --- Centered Form Card --- */}
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="change-pass-card shadow-sm border-0">
              <Card.Body className="p-4">
                <Form onSubmit={handleChangePassword}>
                  {error && <Alert variant="danger" className="py-2 small mb-4">{error}</Alert>}
                  {success && <Alert variant="success" className="py-2 small mb-4">{success}</Alert>}

                  <Form.Group className="mb-4">
                    <Form.Label className="custom-form-label">Current Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter current password"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      required
                      className="custom-input-field shadow-none"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="custom-form-label">New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="At least 6 characters"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      className="custom-input-field shadow-none"
                    />
                  </Form.Group>

                  <Form.Group className="mb-5">
                    <Form.Label className="custom-form-label">Confirm New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Repeat new password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      className="custom-input-field shadow-none"
                    />
                  </Form.Group>

                  <Button variant="danger" type="submit" disabled={loading} className="btn-update-pass w-100">
                    {loading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Processing...
                        </>
                    ) : 'Update Password'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
            
            <div className="text-center mt-4">
                <p className="text-white small">Need help? <a href="#" style={{color: '#F3aa01', fontWeight: 'bold', textDecoration: 'none'}}>Contact Support</a></p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChangePasswordPage;